module.exports = __webpack_public_path__ + "img/lang-icon.47b7b84c.svg";